import {
    AssociatedDocuments as AssociatedDocumentsType,
    BibliographicReference,
} from '@livv/models';
import { Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import Analyses from './Analyses';
import Bibliography from './Bibliography';
import Citations from './Citations';
import Statistics from './Statistics';
import YearlyDecisions from './YearlyDecisions/YearlyDecisions';

interface AssociatedDocumentsProps {
    associatedDocuments?: AssociatedDocumentsType;
    bibliography: BibliographicReference[];
    decisionYear: number;
    focusedAnalysisId?: string;
}

const titleSx = {
    fontSize: 'h4.fontSize',
    pb: 2,
};

const AssociatedDocuments: FC<AssociatedDocumentsProps> = ({
    associatedDocuments,
    bibliography,
    decisionYear,
    focusedAnalysisId,
}) => {
    const { t } = useTranslation('decision');

    if (!associatedDocuments && !bibliography) {
        return null;
    }

    const [analysesOutput, citationsOutput, statisticsOutput] = associatedDocuments ?? [];

    const hasSideContent =
        bibliography.length > 0 ||
        (statisticsOutput?.status === 'ok' && statisticsOutput.statistics.length > 0) ||
        (citationsOutput?.status === 'ok' && citationsOutput?.citations.length > 0);

    // displaying title only if at least one resource is loaded
    return (
        <>
            <Analyses
                analysesOutput={analysesOutput}
                focusedAnalysisId={focusedAnalysisId}
                sx={titleSx}
            />
            {hasSideContent && (
                <>
                    <Typography sx={titleSx} variant="h2" gutterBottom>
                        {t('resources.title')}
                    </Typography>
                    <Statistics statisticsOutput={statisticsOutput} />
                    <Citations citationsOutput={citationsOutput} />
                    {bibliography.length > 0 && <Bibliography bibliography={bibliography} />}
                    <YearlyDecisions decisionYear={decisionYear} />
                </>
            )}
        </>
    );
};

export default AssociatedDocuments;
